import { APP_PATHS } from '../../constants/appPaths';

export const SYSTEM_SETTINGS_SECTIONS = {
  GERAL: 'geral',
  LIXEIRA: 'lixeira',
};

/** Chave em `location.state` para abrir uma seção ao redirecionar para `/settings`. */
export const OPEN_SETTINGS_SECTION_STATE = 'openSettingsSection';

export const getSettingsPathWithSection = (sectionId) => ({
  pathname: APP_PATHS.SETTINGS,
  state: { [OPEN_SETTINGS_SECTION_STATE]: sectionId },
});
